<template>
    <div class="home">
        <div class="content-overlay"></div>
        <section class="board container-fluid">
            <div class="page-header margin-top-md mobile-margin-top-0">La pagina che cercavi non è stata trovata</div>
        </section>
        <section class="board container-fluid">
            <div>
                <h3></h3>

                <div class="banner-lev3a">
                    <img class="multidevice-image" data-desktop="https://static.erickson.it/sit/storefront/banner_iii/tipo_a/error/errore-404_desk.png" data-tablet="https://static.erickson.it/sit/storefront/banner_iii/tipo_a/error/errore-404_tab.png" data-mobile="https://static.erickson.it/sit/storefront/banner_iii/tipo_a/error/errore-404_mob.png" alt="" src="https://static.erickson.it/sit/storefront/banner_iii/tipo_a/error/errore-404_desk.png">
                </div>

                <div style="text-align: center; margin-top:30px;">
                    <h1>Oooops!</h1>
                    <br>
                    <h6>Qualcosa non ha funzionato.<br>
                    Scusa per il disagio, stiamo cercando – con l’aiuto dell’Ispettore Ortografoni – di risolvere il “giallo”.</h6>
                    <br>
                    Intanto, se vuoi, puoi continuare a navigare sul nostro sito
                </div>

                <div class="row">
                    <div class="col-12 col-sm-4 offset-sm-4">
                        <button @click="goToHome()" id="my-submit" class="go-to-cart-button button red-button button-full" type="button">Torna alla home</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        methods: {
            goToHome() {
                location.href = 'https://www.erickson.it';
            }
        }
    }
</script>